exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-f537b130] .van-grid-item .van-grid-item__content{background-color:rgba(255,255,0,0);padding:0}.title_cell[data-v-f537b130]{padding:0 1px;background-color:transparent}[data-v-f537b130] .van-swipe__indicator{background-color:#1989fa}[data-v-f537b130] .van-swipe__indicators{bottom:5px}", ""]);

// exports
